export default [
  {
    id: 1,
    brand: "Corona Light",
    type: "beer",
    name: "Corona Light Summer Limited Edition",
    img: "https://d3cy9zhslanhfa.cloudfront.net/media/A00BE735-E84A-43D8-811178338E465C9A/5AA28544-BEAB-4D2F-AF38B58843C7A4D4/webimage-16C91E32-E972-4374-A3737016E31A848C.jpg",
    choiceVector: [0, 0, 2],
  },
  {
    id: 2,
    brand: "Svedka",
    type: "spirits",
    name: "SVEDKA Gin Strawberry Pineapple",
    img: "https://d3cy9zhslanhfa.cloudfront.net/media/A00BE735-E84A-43D8-811178338E465C9A/97E691E1-5AC2-4410-8B27E826D2C8A452/webimage-D1DA6F1A-C027-4398-831399681F048D97.png",
    choiceVector: [1, 1, 1],
  },
  {
    id: 3,
    brand: "Kim Crawford",
    type: "wine",
    name: "Kim Crawford Illuminate Rose",
    img: "https://d3cy9zhslanhfa.cloudfront.net/media/A00BE735-E84A-43D8-811178338E465C9A/16AEB085-10CB-4BF1-B912A0D5BCA1AFA6/webimage-4FD641FC-275B-4A1B-93809E472D07F0FD.png",
    choiceVector: [2, 2, 0],
  },
];
